import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "text-h4 ellipsis" }
const _hoisted_2 = { class: "text-subtitle2" }
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import { useDialogPluginComponent } from "quasar"
import SfxBtnIcon from "src/components/button/SfxBtnIcon.vue"
import SfxCardWorkOrder from "src/components/card/SfxCardWorkOrder.vue"
import SfxEmptyPage from "src/components/empty/SfxEmptyPage.vue"
import SfxSearchBar from "src/components/search/SfxSearchBar.vue"
import SfxInfiniteScroll from "src/components/special/SfxInfiniteScroll.vue"
import SfxSkeleton from "src/components/special/SfxSkeleton.vue"
import router from "src/router"
import { useSearchStore } from "src/stores/searchStore"
import { Log } from "src/util/classes/log"
import { EmptyStates } from "src/util/constants/emptyStates"
import { MissingEntityType } from "src/util/enums/entityType"
import { Icons } from "src/util/enums/fontAwesomeIcons"
import { NamedManagerPath } from "src/util/enums/namedPaths"
import { getTranslatedEntityForPage } from "src/util/functions/entity"
import { userHasPermissionToCreateWorkOrder } from "src/util/functions/workOrder"
import { SearchMap } from "src/util/search/searchMap"
import { EntityPages } from "src/util/types/dataModels/entityDefinition"
import { WorkOrderCardData } from "src/util/types/dataModels/workOrder"
import { computed, onMounted, PropType } from "vue"
import { useI18n } from "vue-i18n"

//region Props and Emits


export default /*#__PURE__*/_defineComponent({
  __name: 'SfxDialogListWorkOrderSelect',
  props: {
  entityType: {
    type: String as PropType<EntityPages>,
    required: true,
  },

  entityId: {
    type: String,
    required: true,
  },

  entityDesignation: {
    type: String,
    required: true,
  },

  workOrders: {
    type: Array as PropType<WorkOrderCardData[]>,
    required: true,
  },
},
  emits: [...useDialogPluginComponent.emits],
  setup(__props) {

const props = __props



//endregion

//region Variables

const { t } = useI18n()
const searchStore = useSearchStore()
const { dialogRef, onDialogOK, onDialogCancel } = useDialogPluginComponent()

const searchMap = computed(() => {
  return new SearchMap<WorkOrderCardData, WorkOrderCardData>(
    (workOrder) => [{ term: workOrder.workOrderData.designation, value: workOrder }],
    {},
    props.workOrders
  )
})

const filteredWorkOrders = computed<WorkOrderCardData[] | undefined>(() => {
  return searchStore.term ? searchMap.value.getPartialMatches(searchStore.term) : props.workOrders
})

const translatedEntity = computed(() => getTranslatedEntityForPage(props.entityType))

const subtitle = t("sfxDialogListWorkOrderSelect.subtitle", { entity: translatedEntity.value })

const searchBarDisabled = computed(
  () => !searchStore.enabled || (props.workOrders && props.workOrders.length === 0)
)

//endregion

//region Lifecycle

onMounted(() => {
  searchStore.enabled = true
  searchStore.domain = "workOrders"
})

//endregion

//region Functions

async function handleCreateWorkOrder() {
  if (props.entityType === "item") {
    return await router.push({
      name: NamedManagerPath.CREATE_WORK_ORDER,
      params: { itemId: props.entityId },
    })
  } else if (props.entityType === "issue") {
    return await router.push({
      name: NamedManagerPath.CREATE_WORK_ORDER,
      params: { issueId: props.entityId },
    })
  } else {
    Log.error({ message: "The developer should provide a valid entityType" })
  }
}

function idSelector(workOrder: WorkOrderCardData): string {
  return workOrder.workOrderData.id
}

//endregion

return (_ctx: any,_cache: any) => {
  const _component_q_toolbar_title = _resolveComponent("q-toolbar-title")!
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref_key: "dialogRef",
    ref: dialogRef,
    class: "sfx-dialog-list-manager",
    onHide: _cache[1] || (_cache[1] = ($event: any) => (_unref(searchStore).term = null))
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, { class: "q-dialog-plugin sfx-dialog-work-order-select" }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, { class: "row q-py-sm" }, {
            default: _withCtx(() => [
              _createVNode(SfxBtnIcon, {
                class: "icon-close",
                icon: _unref(Icons).CLOSE_LARGE,
                onClick: _unref(onDialogCancel),
                size: "lg"
              }, null, 8, ["icon", "onClick"]),
              _createVNode(_component_q_toolbar_title, { class: "col q-px-none" }, {
                default: _withCtx(() => [
                  _createElementVNode("span", _hoisted_1, _toDisplayString(props.entityDesignation), 1),
                  _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", { innerHTML: _unref(subtitle) }, null, 8, _hoisted_3)
                  ])
                ]),
                _: 1
              }),
              _createVNode(SfxBtnIcon, {
                class: "icon-create",
                icon: _unref(Icons).WORKORDER_CREATE,
                disable: !_unref(userHasPermissionToCreateWorkOrder)(),
                onClick: _cache[0] || (_cache[0] = ($event: any) => (handleCreateWorkOrder())),
                size: "lg"
              }, null, 8, ["icon", "disable"])
            ]),
            _: 1
          }),
          _createVNode(SfxSearchBar, {
            class: "q-toolbar",
            disable: searchBarDisabled.value
          }, null, 8, ["disable"]),
          _createVNode(_component_q_card_section, { class: "text-subtitle2 q-py-sm" }, {
            default: _withCtx(() => [
              _createElementVNode("span", {
                innerHTML: _unref(t)('sfxDialogListWorkOrderSelect.restriction')
              }, null, 8, _hoisted_4)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_section, { class: "sfx-dialog-list-manager-elements" }, {
            default: _withCtx(() => [
              (props.workOrders.length === 0)
                ? (_openBlock(), _createBlock(SfxEmptyPage, {
                    key: 0,
                    class: "q-py-xl",
                    missingEntity: _unref(EmptyStates).get(_unref(MissingEntityType).WORK_ORDER_NO_SUITABLE_MATCHES)
                  }, null, 8, ["missingEntity"]))
                : (!filteredWorkOrders.value)
                  ? (_openBlock(), _createBlock(SfxSkeleton, {
                      key: 1,
                      "no-of-cards": 3
                    }))
                  : (filteredWorkOrders.value.length === 0)
                    ? (_openBlock(), _createBlock(SfxEmptyPage, {
                        key: 2,
                        class: "q-py-xl",
                        missingEntity: _unref(EmptyStates).get(_unref(MissingEntityType).WORK_ORDER_NO_MATCHES)
                      }, null, 8, ["missingEntity"]))
                    : (_openBlock(), _createBlock(SfxInfiniteScroll, {
                        key: 3,
                        "data-list": filteredWorkOrders.value,
                        "id-selector-function": idSelector
                      }, {
                        default: _withCtx((slotProps) => [
                          _createVNode(SfxCardWorkOrder, {
                            class: "q-my-sm",
                            "work-order": slotProps.data,
                            onClick: ($event: any) => (_unref(onDialogOK)(slotProps.data))
                          }, null, 8, ["work-order", "onClick"])
                        ]),
                        _: 1
                      }, 8, ["data-list"]))
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 512))
}
}

})